module.exports = __webpack_public_path__ + "img/V9.2b2ab493.png";